import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import MenuStyles from 'components/menu/MenuFoot.module.scss';

export class MenuFoot extends Component {
  scrollToTopOfMain = () => {
    let el = document.getElementById('gb-contents');
    el.scrollTop = 0;
  };

  render() {
    return (
      <div className={MenuStyles['menu-foot']}>
        <div className={MenuStyles['menu-foot__controlls']}>
          <NavLink
            to={'/faq'}
            onClick={this.scrollToTopOfMain}
            className={MenuStyles['menu-foot__link']}
            activeClassName={MenuStyles['active']}
          >
            FAQ
          </NavLink>
          <NavLink
            to={'/termos'}
            onClick={this.scrollToTopOfMain}
            className={MenuStyles['menu-foot__link']}
            activeClassName={MenuStyles['active']}
          >
            Termos
          </NavLink>
          <NavLink
            to={'/privacidade'}
            onClick={this.scrollToTopOfMain}
            className={MenuStyles['menu-foot__link']}
            activeClassName={MenuStyles['active']}
          >
            Privacidade
          </NavLink>
        </div>
      </div>
    );
  }
}
